import { Filter } from "@repo/icons";
import { cn } from "@repo/lib";
import { useSearch, useRouter } from "@tanstack/react-router";
import { Button } from "@/components/button";
import {
  MenuDrawer,
  MenuDrawerBodyList,
  MenuDrawerBodyListItem,
  MenuDrawerTitle,
} from "@/components/menu-drawer";
import type { PatientPaymentsPageSearchSchema } from "@/lib/form-schemas/patient-payments-page-search-schema";

interface PaymentFilterMenuFormProps {
  setOpenFilter: (open: boolean) => void;
}

export const PaymentFilterMenuDrawer = ({
  setOpenFilter,
}: PaymentFilterMenuFormProps): JSX.Element => {
  const searchParams = useSearch({
    from: "/settings/payments/patient-payments/",
  });

  const router = useRouter();

  const openFilterDrawer = (): void => {
    void router.navigate({
      search: { ...searchParams, action: "show-filter" },
      replace: true,
    });
  };

  const hasActiveFilters = (filterParams: PatientPaymentsPageSearchSchema): boolean => {
    return Boolean(
      (filterParams.status?.length ?? 0) ||
        (filterParams.origins?.length ?? 0) ||
        (filterParams.paymentMethods?.length ?? 0),
    );
  };

  const hasSelectedFilter = hasActiveFilters(searchParams);

  return (
    <>
      <Button
        onClick={() => {
          openFilterDrawer();
        }}
        Icon={Filter}
        rounded
        size="small"
        className={cn(
          "hover:bg-secondary-400 hover:text-white hover:fill-white",
          !hasSelectedFilter
            ? "bg-white text-secondary-400 fill-secondary-400"
            : "bg-secondary-400 text-white fill-white",
        )}
      >
        Filtros
      </Button>

      <MenuDrawer open={searchParams.action === "show-filter"} setOpen={setOpenFilter}>
        <MenuDrawerTitle>Filtrar por</MenuDrawerTitle>
        <MenuDrawerBodyList>
          <MenuDrawerBodyListItem
            linkProps={{
              to: "/settings/payments/patient-payments/filters/filter-status",
              search: { ...searchParams, action: undefined },
            }}
          >
            Status de pagamento
          </MenuDrawerBodyListItem>
          <MenuDrawerBodyListItem
            linkProps={{
              to: "/settings/payments/patient-payments/filters/filter-payment-methods",
              search: { ...searchParams, action: undefined },
            }}
          >
            Forma de pagamento
          </MenuDrawerBodyListItem>
          <MenuDrawerBodyListItem
            linkProps={{
              to: "/settings/payments/patient-payments/filters/filter-origins",
              search: { ...searchParams, action: undefined },
            }}
          >
            Origem
          </MenuDrawerBodyListItem>
        </MenuDrawerBodyList>
      </MenuDrawer>
    </>
  );
};
